/* eslint-disable react/jsx-max-depth */
import { Line } from '@/components/shared/element/line';
import { Text } from '@/components/shared/element/text';
import LeadForm, { ILeadForm } from '@/components/shared/form/lead-form';
import { Box } from '@/components/shared/layout/box';
import { Container } from '@/components/shared/layout/container';
import { Grid } from '@/components/shared/layout/grid';
import { Section } from '@/components/shared/layout/section';
import { Image } from '@/components/shared/media/image';
import { generateCommonImageSources } from '@/components/shared/media/image/generate-sources';
import { REGISTER_FORM_TITLE } from '@/const/register';
import { styled } from '@/stitches.config';
import { IVehicleType } from '@/types/services/contentstack';
import { IModel } from '@/types/services/lead';
import { IButton } from '@/types/shared';

const ImageWrap = styled('div', {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  pe: 'none',
  '& img': {
    '@maxlg': {
      objectPosition: 'center bottom !important',
    },
    '@maxxs': {
      objectFit: 'contain !important',
    },
  },
});

const ContentWrap = styled('div', {
  position: 'relative',
  '@maxlg': {
    pb: '30%',
  },
  '@lg': {
    pb: '160px',
  },
});

export interface IRegister {
  campaignId?: string;
  campaignVersion?: string;
  campaignName?: string;
  title?: string;
  button?: IButton[];
  successURL?: string;
  imgMobileURL?: string;
  imgDesktopURL?: string;
  isNameAndTel?: boolean;
  lcvModel?: IModel;
  vehicleType?: IVehicleType;
  showVehicleType?: false | boolean;
  remark?: string;
}

const View = (props: IRegister) => {
  const formData: ILeadForm = {
    title: REGISTER_FORM_TITLE,
    campaignName: props.campaignName,
    campaignId: props.campaignId,
    campaignVersion: props.campaignVersion,
    successURL: props.successURL,
    lcvModel: props.lcvModel,
    vehicleType: props.vehicleType && props.vehicleType,
    showVehicleType: props.showVehicleType,
    remark: props.remark && props.remark,
  };

  return (
    <Section size="2xl" backgroundColor="white">
      {!!(props.imgDesktopURL || props.imgMobileURL) && (
        <ImageWrap>
          <Image
            priority
            src={props.imgMobileURL || props.imgDesktopURL || ''}
            alt={props.title || 'Register'}
            width={600}
            height={400}
            layout="fill"
            objectFit="cover"
            sources={generateCommonImageSources({
              mobileSrc: props.imgMobileURL || props.imgDesktopURL,
              desktopSrc: props.imgDesktopURL,
            })}
          />
        </ImageWrap>
      )}
      <ContentWrap>
        <Section as="div">
          <Container>
            <Grid templateColumns={{ '@lg': '12' }} columnGap="2" rowGap="7">
              <Box
                css={{
                  '@lg': {
                    gridColumn: '1 / span 5',
                  },
                }}
              >
                <Grid data-test="content_register" rowGap="7">
                  <Box>
                    {!!props.campaignName && (
                      <Text
                        data-test="header"
                        as="h1"
                        size="h2"
                        wrap
                        dangerouslySetInnerHTML={{
                          __html: props.campaignName,
                        }}
                      />
                    )}
                    <Line size="3" />
                    {!!props.title && (
                      <Text
                        data-test="description"
                        as="h2"
                        size="h6"
                        font="bold"
                        wrap
                        dangerouslySetInnerHTML={{ __html: props.title }}
                      />
                    )}
                  </Box>
                </Grid>
              </Box>
              <Box
                css={{
                  '@lg': {
                    gridColumn: '7 / span 5',
                  },
                }}
              >
                <LeadForm {...formData} />
              </Box>
            </Grid>
          </Container>
        </Section>
      </ContentWrap>
    </Section>
  );
};
View.displayName = 'SectionRegister';
export default View;
